import React from "react";

import "./ImagePreview.scss";
import { Preview } from "../../utils/Constant";
import MUIIcons from "../MUIIcon/MUIIcons";

interface ImagePreviewProps {
  imageUrl: string;
  fileName: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  imageUrl,
  fileName,
}) => {
  return (
    <div className="image-preview">
      <div className="preview-container">
        <img src={imageUrl} alt="Preview" className="preview-image" />
        <div className="preview-overlay">
          <MUIIcons iconName="CheckOutlined" size={24} />
        </div>
      </div>

      <div className="preview-info">
        <h4>{Preview}</h4>
        <p className="file-name">{fileName}</p>
      </div>
    </div>
  );
};
